import "../styles/genai.css";
import heroImg from "../assets/ai-hero.png";

export default function GenAIHero() {
  return (
    <>
      {/* ================= HERO ================= */}
      <section className="genai-hero full-hero">

        {/* OVERLAY */}
        <div className="hero-overlay"></div>

        {/* CONTENT */}
        <div className="hero-content">


          <h1 className="hero-title">
            GEN AI STARTER PROGRAM
          </h1>

          <p className="hero-desc">
            Learn to Build Real-World Generative AI Applications
          </p>

          <div className="hero-badges">
           
          </div>
        </div>
      </section>

    </>
  );
}
